import { request } from './http';
import type {
  CatalogResponse,
  ExecuteRunPayload,
  LabRun,
  LabSession,
  LabWebhookListResult,
  RunListResult,
  SessionListResult,
} from '@/types/upstreamLab';

export const upstreamLabApi = {
  getCatalog() {
    return request<CatalogResponse>({ url: '/admin/upstream-lab/catalog', method: 'GET' });
  },

  listSessions(page = 1, pageSize = 20) {
    return request<SessionListResult>({
      url: '/admin/upstream-lab/sessions',
      method: 'GET',
      params: { page, pageSize },
    });
  },

  createSession(payload: { name: string; note?: string; artifacts?: Record<string, unknown> }) {
    return request<LabSession>({
      url: '/admin/upstream-lab/sessions',
      method: 'POST',
      data: payload,
    });
  },

  getSession(sessionId: string) {
    return request<LabSession>({
      url: `/admin/upstream-lab/sessions/${sessionId}`,
      method: 'GET',
    });
  },

  patchSession(sessionId: string, payload: Partial<{ name: string; note: string; artifacts: Record<string, unknown> }>) {
    return request<LabSession>({
      url: `/admin/upstream-lab/sessions/${sessionId}`,
      method: 'PATCH',
      data: payload,
    });
  },

  deleteSession(sessionId: string) {
    return request<null>({
      url: `/admin/upstream-lab/sessions/${sessionId}`,
      method: 'DELETE',
    });
  },

  patchArtifacts(sessionId: string, artifacts: Record<string, unknown>, merge = true) {
    return request<LabSession>({
      url: `/admin/upstream-lab/sessions/${sessionId}/artifacts`,
      method: 'POST',
      data: { artifacts, merge },
    });
  },

  executeRun(sessionId: string, payload: ExecuteRunPayload) {
    return request<LabRun>({
      url: `/admin/upstream-lab/sessions/${sessionId}/runs`,
      method: 'POST',
      data: payload,
    });
  },

  listRuns(sessionId: string, page = 1, pageSize = 20) {
    return request<RunListResult>({
      url: `/admin/upstream-lab/sessions/${sessionId}/runs`,
      method: 'GET',
      params: { page, pageSize },
    });
  },

  getRun(sessionId: string, runId: string) {
    return request<LabRun>({
      url: `/admin/upstream-lab/sessions/${sessionId}/runs/${runId}`,
      method: 'GET',
    });
  },

  listWebhooks(
    sessionId: string,
    params?: { outTradeNo?: string; upstreamCardId?: string; page?: number; pageSize?: number },
  ) {
    return request<LabWebhookListResult>({
      url: `/admin/upstream-lab/sessions/${sessionId}/webhooks`,
      method: 'GET',
      params,
    });
  },

  generateOrderNo(prefix = 'LAB') {
    return request<{ outTradeNo: string }>({
      url: '/admin/upstream-lab/utils/order-no',
      method: 'POST',
      params: { prefix },
    });
  },
};
